import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import { ChainId } from 'constants/constants';

type Props = {
  depositTokenDisplayName: string;
  chainId: ChainId;
};

const VaultTooltip: React.FC<Props> = (props) => {
  // exception for ETH vault: either ETH or wETH could be deposited
  const isEthVault =
    props.depositTokenDisplayName === 'wETH' &&
    props.chainId !== ChainId.Polygon &&
    props.chainId !== ChainId.Celo;
  const depositTokenDisplayName = isEthVault
    ? 'ETH (or $wETH)'
    : (props.depositTokenDisplayName === 'ETHC' ? 'ETH' : props.depositTokenDisplayName);

  return (
    <div className="section-description vault-description text-left">
      <b>Tip:</b> Deposit only ${depositTokenDisplayName} and receive LP tokens
      representing your share of the vault. These tokens will automatically earn
      fees in both assets listed below proportional to your share of the pool
      and can be redeemed at any time.
      {isEthVault && (
        <span className="ml-1">
          Upon withdrawal ETH assets will be returned as wETH.
        </span>
      )}
      <OutboundLink
        href="https://docs.ichi.org/home/yield-iq-strategy"
        className="ml-4 selected-color font-medium"
        target="blank"
      >
        Learn about Vaults
      </OutboundLink>
      <br />
      <br />
      Depositing to a vault comes with risks:
      <OutboundLink
        href="https://docs.ichi.org/home/disclaimer"
        className="ml-4  selected-color font-medium"
        target="blank"
      >
        Learn More
      </OutboundLink>
    </div>
  );
};

export default VaultTooltip;
